import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import React from 'react';
export const getLicenseCheckAnalyticsCardIcon = (status) => {
    switch (status) {
        case 'expired':
            return React.createElement(RemoveCircleIcon, { htmlColor: themeColors.accent.grey.bold });
        case 'notVerified':
            return React.createElement(ErrorIcon, { htmlColor: themeColors.accent.blue.bold });
        case 'verified':
            return React.createElement(CheckCircleIcon, { htmlColor: themeColors.accent.green.bold });
        case 'failed':
            return React.createElement(CancelIcon, { htmlColor: themeColors.accent.red.bold });
        default:
            return null;
    }
};
export const licenseCheckAnalyticsFilterMap = {
    expired: ['expired', 'cvoExpired'],
    verified: ['verified', 'verifiedExpirationUpdated'],
    notVerified: ['readyToVerify', 'notChecked', 'missingFields'],
    failed: ['notVerified', 'inactive', 'noMatchFound', 'multipleMatchesFound', 'outOfState'],
};
